import { ArrowRightOutlined } from '@ant-design/icons';
import { useRef } from 'react';
import styled from 'styled-components';

import AIIcon from '@/components/Badge/AIBadge/AIIcon';
import { Flex } from '@/components/base';
import IconButton from '@/components/Button/IconButton';
import keymap from '@/utils/keymap';

type Props = {
  onAskSyncly: (value: string) => void;
  style?: React.CSSProperties;
  placeholder?: string;
};

const AskSynclyFloat = (props: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (keymap.isEnter(e)) {
      const prompt = e.currentTarget.value;
      props.onAskSyncly(prompt);
    }
  };

  return (
    <StyledContainer j="center" a="center" g={8} style={props.style}>
      <AIIcon className="text-base" />
      <input
        placeholder={props.placeholder || 'Ask anything'}
        onKeyDown={onKeyDown}
        ref={inputRef}
      />
      <IconButton
        outlined={false}
        sizeType="m"
        icon={<ArrowRightOutlined />}
        onClick={() => {
          const value = inputRef.current?.value || '';
          props.onAskSyncly(value);
        }}
      />
    </StyledContainer>
  );
};

const StyledContainer = styled(Flex)`
  position: absolute;
  bottom: 24px;
  left: 50%;
  height: 44px;
  transform: translateX(-50%);
  background-color: ${({ theme }) => theme.colors.gray100};
  border-radius: 32px;
  padding: 0px 10px 0px 16px;
  max-width: 100%;
  z-index: 10;
  box-shadow: ${({ theme }) => theme.shadow[4]};
  border: 0.5px solid ${({ theme }) => theme.colors.gray400};
  width: 480px;
  input {
    flex: 1;
    font-size: 14px;
    border: none;
    background: transparent;
    color: ${({ theme }) => theme.colors.gray800};
    &::placeholder {
      color: ${({ theme }) => theme.colors.gray600};
    }
    &:focus {
      outline: none;
    }
  }
`;

export default AskSynclyFloat;
